import { render } from "./FABPropsCmp.vue?vue&type=template&id=07b87087"
import script from "./FABPropsCmp.vue?vue&type=script&lang=js"
export * from "./FABPropsCmp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__